export default {
  USA: 'us',
  Canada: 'ca',
  Australia: 'au',
};
